/* Keeps [data-u7-cart-total] in sync. Dawn re-renders #cart-icon-bubble on every
   cart change via the Section Rendering API; we observe it and refetch the total. */
(function () {
  const fmt = (cents) => {
    try {
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, window.U7_MONEY_FORMAT || '${{amount}}')
        : '$' + (cents / 100).toFixed(2);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  async function refresh() {
    try {
      const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-u7-cart-total]').forEach((el) => {
        el.textContent = fmt(cart.total_price);
        el.classList.toggle('u7-cart-total--empty', cart.item_count === 0);
      });
    } catch (e) { /* no-op */ }
  }
  // Dawn re-renders #cart-icon-bubble's innerHTML on every cart change (Section
  // Rendering API). The total span renders OUTSIDE #cart-icon-bubble, so observing
  // the bubble and writing to [data-u7-cart-total] is loop-safe.
  const bubble = document.querySelector('#cart-icon-bubble');
  if (bubble) {
    new MutationObserver(refresh).observe(bubble, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', refresh);
})();
